module.exports = __webpack_public_path__ + "media/images/client/favicons/site-tile-70x70-62394729897c7b2f89d76ffb6b9ab2fa.png";